import produce from "immer";
import { ActionType, LogOutAction, SetCurrentUserAction } from "auth/actions";

export type AllAuthActions = LogOutAction | SetCurrentUserAction;

export interface AuthState {
  user: User | null;
  status: AuthStatus;
}

export const initialState: AuthState = {
  user: null,
  status: "initial",
};

export const authReducer = (state = initialState, action: AllAuthActions) =>
  produce(state, draft => {
    switch (action.type) {
      case ActionType.LogOut: {
        return initialState;
      }
      case ActionType.SetCurrentUser: {
        draft.user = action.payload;
        draft.status = draft.user === null ? "logged-out" : "logged-in";
        return draft;
      }
      default:
        return draft;
    }
  });
